import React from 'react'
import { MerchantLocationsLoader } from 'router/Loaders'
import { ManageIntegrations } from 'components/Integrations/Manage'
import IntegrationModuleLoaders from 'router/Loaders/PartnerDataLoaders'

// The integration Loaders are mounted persistently in LayoutWrapper
// (doc/ARCHITECTURE.md §6.3); mounting them here would duplicate the fetch.
export const ManageIntegrationsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <IntegrationModuleLoaders isParentLoaded={isParentLoaded}>
          <ManageIntegrations />
        </IntegrationModuleLoaders>
      )}
    </MerchantLocationsLoader>
  )
}
